import { PropsWithChildren, ReactNode } from 'react'

import { AstraAvatar, AstraParagraph, AstraTooltip, day, humanizeDate } from '~/astra'
import { getTimeStampText } from '~/utils/getTimeStampText'

type Props = {
    icon: ReactNode
    performedBy: string
    initials: string
    performedAt: string
}

export const ActivityLogEntryWrapper = ({ icon, performedBy, initials, performedAt, children }: PropsWithChildren<Props>) => (
    <div className="grid grid-cols-[66px_1fr_auto] items-center gap-2">
        <div className="flex items-center justify-center self-start bg-surface-base py-1">{icon}</div>
        <div className="flex flex-col gap-2">
            <div className="flex max-w-64 items-center gap-2">
                {performedBy ? (
                    <AstraTooltip tooltipContent={performedBy}>
                        <div className="pointer-events-auto self-start">
                            <AstraAvatar variant="initial" initials={initials} size="medium" useColorGenerator />
                        </div>
                    </AstraTooltip>
                ) : (
                    <AstraParagraph variant="body">[Ukjent Bruker]</AstraParagraph>
                )}
                {children}
            </div>
        </div>
        <AstraTooltip tooltipContent={humanizeDate(day(performedAt))}>
            <AstraParagraph variant="body" className="ml-4 justify-self-end text-subtle">
                {getTimeStampText(performedAt)}
            </AstraParagraph>
        </AstraTooltip>
    </div>
)
